import { EventBus } from '@/event-bus'
import moment, { Moment } from 'moment'
import { AlertTypes } from '@/models/alert-data.model'
import { IFormField } from '@/models/classes/FormField'
import notifMessage from '@/translations/notifMessage.json'
import labels from '@/translations/labels.json'
import * as HELPERS from '@/utils/helpers'
import CONSTANTS from '@/constants/Config.constants'
export function getAcronyme(text: string): string {
  return text.substring(0, 2)
}
export function scrollToTop(): void {
  document.body.scrollTop = document.documentElement.scrollTop = 0
}

export function formatDate(value: string): string | undefined {
  if (value) {
    const formatted = moment(String(value)).format('DD.MM.YYYY hh:mm:ss')
    return formatted
  }
}
// Formats a given Date into a string according to the system's locale preferences as detailed date time. Example: "Wed, 10 April 2024, 13:45".
export function formatLocalDateTime(date: Date): string {
  return moment(date).format('ddd, D MMMM YYYY, HH:mm')
}

export function formatDateNoTime(date: string | Moment): string {
  return moment(date).format('YYYY.MM.DD')
}

export function isSameDate(beginDate: Date, endDate: Date) {
  return moment(beginDate).isSame(moment(endDate), 'day')
}

export function replaceVariableInString(value: string, ...variables: Array<string>): string {
  let returnedString = value
  if (variables.length === 1 && value.indexOf('%%string%%') !== -1) {
    returnedString = value.replace('%%string%%', variables[0])
  } else {
    variables.forEach((item: string, index: number) => {
      returnedString = returnedString.replace(`%%string${index + 1}%%`, item)
    })
  }
  return returnedString
}

export function showTopAlertMessage(isShown: boolean, type: AlertTypes, message: string): void {
  scrollToTop()
  const displayAlertMsg = {
    type,
    message,
    isShown,
  }
  EventBus.emit('showTopAlertMessage', displayAlertMsg)
}

export function RandomString(): string {
  let outString = ''
  const inOptions = 'abcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < 6; i++) {
    outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length)).toUpperCase()
  }

  return outString
}

export function formatStringToCamelCase(string: string): string {
  return string.toLowerCase().trim().charAt(0).toUpperCase() + string.toLowerCase().slice(1)
}

export function getTimeZone(time: number): string {
  return moment.unix(time).format()
}

export function requireDefined<T>(val: T | undefined): T {
  if (val === undefined) {
    throw Error(notifMessage.ERROR_ALERTS.SOMETHING_WENT_WRONG)
  }

  return val
}

export function assertUnreachable(x: never): never {
  throw new Error(`Didn't expect to get here: ${x}`)
}

export function getCreationDateOnly(date: string): string {
  return moment(date).format('ddd MMM D YYYY HH:mm')
}

export function buildFormatsMsg(): string {
  let formats = ''
  const allowedFilesFormats: string[] = CONSTANTS.SNAPSHOT.ALLOWED_FORMATS
  const allowedFilesMsg = notifMessage.ERROR_ALERTS.WRONG_FORMAT
  const allowedFilesMsgExists =
    allowedFilesMsg !== undefined &&
    Object.entries(allowedFilesMsg).length > 0 &&
    allowedFilesMsg.SINGLE_FORMAT !== undefined
  if (allowedFilesFormats.length === 1 && allowedFilesMsgExists) {
    formats = replaceVariableInString(allowedFilesMsg.SINGLE_FORMAT, allowedFilesFormats[0])
  }

  const message = formats !== '' ? `${allowedFilesMsg.TEXT + formats}` : ''
  return message
}

export function hasValidExtension(filename: string): boolean {
  const regex = /.*\..*snapshot(?!\.zip$).*$/
  return regex.test(filename as string)
}

export function parseIntUndefined(number?: string): number | undefined {
  if (!number) {
    return undefined
  }

  const result = parseInt(number)

  if (isNaN(result)) {
    return undefined
  }

  return result
}

export function validateInput(field: IFormField): void {
  let fieldLimit: any, label: any
  switch (field.name) {
    case 'projectName':
      fieldLimit = CONSTANTS.MAX_LENGTH_INPUT
      label = labels.HOMEPAGE.PROJECT_DIALOG.PROJECT_NAME
      break
    default:
      break
  }
  field.isDirty = false
  field.isEmpty = field.value.trim() === ''
  if (field.value.trim() === '') field.value = ''
  field.infoMessage =
    field.value.length >= fieldLimit
      ? HELPERS.replaceVariableInString(
          notifMessage.INSTANT_ALERTS.LENGTH_LIMIT_FIELDS,
          label,
          `${fieldLimit}`,
        )
      : ''
}
